import { useEffect } from "react"
import * as Sentry from "@sentry/react"
import { createRoutesFromChildren, useNavigationType, matchRoutes, useLocation } from "react-router-dom"

import { getConfig } from "@components/Config"
import { isBackstage, isLocal } from "@components"

const PLATFORM_VERSION = getConfig("PLATFORM_VERSION")
const SENTRY_ENVIRONMENT = getConfig("SENTRY_ENVIRONMENT")
const SENTRY_INVESTOR_DNS = getConfig("SENTRY_INVESTOR_DNS")
const SENTRY_BACKSTAGE_DNS = getConfig("SENTRY_BACKSTAGE_DNS")

const SENTRY_DNS = isBackstage
  ? SENTRY_BACKSTAGE_DNS
  : SENTRY_INVESTOR_DNS


const initializeSentry = () => {
  if (isLocal) {
    return
  }

  Sentry.init({
    dsn: SENTRY_DNS,
    environment: SENTRY_ENVIRONMENT,
    release: PLATFORM_VERSION,
    ignoreErrors: [
      'Failed to fetch',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured with value: Object Not Found',
      'Non-Error promise rejection captured with value: The user is not authenticated',
      'Non-Error promise rejection captured with value: undefined',
      'UnhandledRejection: Object captured as promise rejection with keys: [object has no keys]',
      // Wallet/provider user-initiated errors (e.g. code 4001 "wallet must has at least one account")
      'UnhandledRejection: Object captured as promise rejection with keys: code, message',
      // Vimeo embed: video removed or private (BACKSTAGE-8Q)
      'NotFoundError: This video does not exist.',
      // Vimeo embed: fetch/embed failure, e.g. network or invalid embed (BACKSTAGE-8N)
      'There was an error fetching the embed code from Vimeo.',
      // Plaid Link: postMessage origin mismatch in edge-case browsers (e.g. DuckDuckGo in-app) (#2712)
      'Error: invalid origin',
      // YouTube iframe API: third-party script load failure (INVESTOR-PORTAL-58 / #2714)
      'Error: Failed to load https://www.youtube.com/iframe_api',
      // Sentry performance issue: Large HTTP payload (INVESTOR-PORTAL-45 / #2718)
      'Large HTTP payload',
      // Sentry performance issue: Large Render Blocking Asset (INVESTOR-PORTAL-7 / #2720)
      'Large Render Blocking Asset',
    ],
    // beforeSend(event) {
    //   if (event.message) {
    //     event.fingerprint = [event.message, event.message];
    //   }
    //   return event;
    // },
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  })
}

export default initializeSentry
